import React from 'react';
import { Heading } from '../../components';
import css from './ListingPage.module.css';
import { FormattedMessage } from 'react-intl';
const ResumeMayBe = props => {
  const { metadata } = props || {};

  const { file } = metadata || {};
  return file ? (
    <div className={css.sectionDetails}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ListingPage.ResumeMayBe.resumeLabel" />
      </Heading>
      <a href={file.link} target="__blank" className={css.resume}>
        <FormattedMessage id="ListingPage.ResumeMayBe.downloadResume" />
      </a>
    </div>
  ) : null;
};

export default ResumeMayBe;
